module.exports = __webpack_public_path__ + "img/ts-galaxy.e6370ac9.png";